module.exports = __webpack_public_path__ + "static/media/no-used-perks.21af9dc4.svg";